// removed by extract-text-webpack-plugin
module.exports = {"header":"_3v_A5UxgQqwMhxYwIs1TrP","large":"_2-Vps4kr4oKsKbZnCNJ4iC","small":"_2CVJfB-eKMh6KQVmKdiWDM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.scss
// module id = 450
// module chunks = 0